import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Typography,
  Paper,
  Divider,
  IconButton,
  Button,
  Stack,
  Select,
  MenuItem,
  Pagination,
  PaginationItem,
  Grid,
} from "@mui/material";
import EditButton from "../../../assets/icons/EditButton.svg";
import TrashButton from "../../../assets/icons/TrashButton.svg";
import React, { useState, useEffect } from "react";
import BackArrow from "../../../assets/icons/BackArrow.svg";
import { useDispatch, useSelector } from "react-redux";
import ActiveAddButton from "../../../assets/icons/ActiveAddButton.svg";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import CircularProgress from "@mui/material/CircularProgress";
import AddNotificationBroadcastModel from "./AddNotificationBroadcastModel";
import noData from "../../../assets/images/Group 688.png";
import { setIsOpenModelAddSendNotificationMaster } from "../../../redux/actions/mastersAction";
import { setLoaderSaveButton } from "../../../redux/actions/userActions";

const NotificationBroadcastContent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state?.user?.isLoading);
  const sendNotificationMasterData = useSelector(
    (state) => state?.masters?.sendNotificationMasterData
  );

  const [isAddNotificationBroadcastModel, setIsAddNotificationBroadcastModel] =
    useState(false);
  const [isPaginationLimit, setIsPaginationLimit] = useState("");

  const handleChangeIsPaginationLimit = (event) => {
    setIsPaginationLimit(event.target.value);
  };

  const handleCloseAddNotificationBroadcastModel = (e) => {
    setIsAddNotificationBroadcastModel(false);
  };

  useEffect(() => {
    dispatch(setIsOpenModelAddSendNotificationMaster(false));
    dispatch(setLoaderSaveButton(false));
  }, []);

  return (
    <>
      <AddNotificationBroadcastModel />

      <Paper
        sx={{
          width: "auto",
          height: "auto",
          overflow: "auto",
          borderRadius: "10px",
        }}
      >
        <Box
          sx={{
            height: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
            overflow: "auto",
            width: "auto",
            "&::-webkit-scrollbar": {
              width: "5px",
              height: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#20724E",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#E5F1EB",
            },
          }}
        >
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                display: "flex",
                ml: 2,
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/masters");
              }}
            >
              <img src={BackArrow} alt="" width="17" height="17" />
            </Box>
            <Box>
              <Typography
                sx={{
                  ml: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#212121",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Send Notification Master
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mr: 6 }}>
            <Button
              variant="outlined"
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                borderColor: "#26875C",
                width: "6rem",
                backgroundColor: "FFFFFF",
                padding: "6px 0px 4px 0px",
                borderRadius: "10px",
                textTransform: "capitalize",
                color: "#26875C",
                ":hover": {
                  borderColor: "#26875C",
                },
              }}
              onClick={() =>
                dispatch(setIsOpenModelAddSendNotificationMaster(true))
              }
            >
              <Box sx={{ marginRight: "10px" }}>
                <img src={ActiveAddButton} alt="" />
              </Box>
              Add
            </Button>
          </Box>
        </Box>
        <Divider sx={{ width: "auto" }} />

        <Box sx={{ margin: "10px 25px 20px 25px" }}>
          <TableContainer
            sx={{
              maxHeight: "620px",
              "&::-webkit-scrollbar": {
                width: "5px",
                height: "3px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#20724E",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#E5F1EB",
              },
            }}
          >
            {sendNotificationMasterData?.length <= 0 ? (
              <Grid sx={{ paddingTop: "20px" }}>
                <Grid
                  item
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box>
                    <Box
                      component="img"
                      sx={{
                        height: "25rem",
                        width: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      alt=""
                      src={noData}
                    />
                  </Box>
                  <Box
                    fontWeight="600"
                    sx={{ padding: "20px", fontWeight: "600" }}
                  >
                    <Typography sx={{ fontWeight: "600", fontSize: "18px" }}>
                      No Data Found
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Notification Name
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Description
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Vessel Name
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Created Date
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Action
                    </TableCell> */}
                  </TableRow>
                </TableHead>
                {isLoading ? (
                  <TableBody>
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        height: "10rem",
                      }}
                    >
                      <TableCell colSpan={9} align="center">
                        <CircularProgress color="success" />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {sendNotificationMasterData?.map((row, index) => (
                      <TableRow
                        // key={row.Checklist}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          sx={{
                            color: "#464E5F",
                            fontWeight: "600",
                          }}
                        >
                          {row?.title}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                          {row?.description}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                          {row?.vessel === null ? "All" : row?.vessel}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                          {moment(row?.createdAt).format(
                            "D MMMM, YYYY | hh:mm A"
                          )}
                        </TableCell>
                        {/* <TableCell
                          sx={{
                            color: "#464E5F",
                            fontWeight: 600,
                            textAlign: "left",
                          }}
                        >
                        
                          <IconButton
                          onClick={() => handleDeleteCompanyAdmin(row?.id)}
                          >
                            <img src={TrashButton} width="30" height="30" />
                          </IconButton>
                        </TableCell> */}
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            )}
          </TableContainer>
          <Divider />
          {/* {sendNotificationMasterData.length > 0 && (
            <Stack
              spacing={2}
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              sx={{
                padding: "1rem",
                marginTop: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ mr: "8px" }}>Row Per Page</Typography>
                <Select
                  value={isPaginationLimit}
                  onChange={handleChangeIsPaginationLimit}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  IconComponent={() => (
                    <Box
                      sx={{
                        marginRight: "10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={ArrowDown}
                        alt="Custom Icon"
                        width="18"
                        height="24"
                      />
                    </Box>
                  )}
                  sx={{
                    height: "37px",
                    width: "6rem",
                    color: "#20724E",
                    fontWeight: "bold",
                    borderRadius: "10px",
                    border: "none",
                    backgroundColor: "#E5F1EB",
                    mr: 2,
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      border: "1px solid #E5F1EB",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  <MenuItem value="">10</MenuItem>
                  <MenuItem value={10}>20</MenuItem>
                  <MenuItem value={20}>30</MenuItem>
                </Select>
              </Box>
              <Box>
                <Pagination
                  count={10}
                  renderItem={(item) => (
                    <PaginationItem
                      slots={{
                        previous: ArrowBackIcon,
                        next: ArrowForwardIcon,
                      }}
                      {...item}
                    />
                  )}
                />
              </Box>
            </Stack>
          )} */}
        </Box>
      </Paper>
    </>
  );
};

export default NotificationBroadcastContent;
